import React from 'react';
import { Task } from '../../../models/task.model';

interface Props {
    isOpen: boolean;
    task: Task | null;
    onClose: () => void;
}

export const TaskDetailsModal: React.FC<Props> = ({ isOpen, task, onClose }) => {
    if (!isOpen || !task) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
            <div className="bg-white rounded-[2rem] shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
                
                {/* Header */}
                <div className="p-8 border-b border-slate-50 flex justify-between items-center bg-slate-50/50">
                    <div>
                        <h3 className="text-xl font-black text-slate-800 tracking-tight">{task.title}</h3>
                        <p className="text-[10px] font-bold text-slate-400 uppercase">Feladat részletes információi</p>
                    </div>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600 text-3xl transition-colors">&times;</button>
                </div>

                {/* Tartalom */}
                <div className="p-8 space-y-6">
                    <div>
                        <label className="block text-[10px] font-black uppercase text-blue-600 mb-2">Feladat leírása</label>
                        <div className="bg-slate-50 border border-slate-100 rounded-xl p-4 text-sm text-slate-700 whitespace-pre-wrap leading-relaxed min-h-[100px]">
                            {task.description}
                        </div>
                    </div>

                    {/* Meta adatok */}
                    <div className="grid grid-cols-2 gap-4 bg-slate-50/50 p-4 rounded-xl border border-slate-100 text-[11px] font-medium text-slate-500">
                        <div>
                            <span className="block text-[9px] font-black uppercase text-slate-400">Létrehozó</span>
                            <span className="text-slate-800 font-bold">{task.creator?.name || `ID: ${task.creatorId}`}</span>
                        </div>
                        <div>
                            <span className="block text-[9px] font-black uppercase text-slate-400">Felelős</span>
                            <span className="text-slate-800 font-bold">{task.assignee?.name || `ID: ${task.assigneeId}`}</span>
                        </div>
                        <div>
                            <span className="block text-[9px] font-black uppercase text-slate-400">Dátum</span>
                            <span>{new Date(task.date).toLocaleDateString()}</span>
                        </div>
                        <div>
                            <span className="block text-[9px] font-black uppercase text-slate-400">Állapot</span>
                            <span className="font-bold text-blue-600">{task.taskState}</span>
                        </div>
                    </div>

                    {/* Leokézó / Bezáró Gomb */}
                    <button 
                        onClick={onClose}
                        className="w-full py-4 bg-slate-800 hover:bg-slate-900 rounded-2xl font-black uppercase tracking-widest text-white transition-all shadow-lg active:scale-95"
                    >
                        Értettem / Bezárás
                    </button>
                </div>
            </div>
        </div>
    );
};